import moment from 'moment';
import getColour from '@lendi-ui/commons/colours';

import { Body } from '@funnels/ui-components';
import { validateDate } from '@funnels/utils';

import { AccordionHeaderContainer, AccordionHeaderText } from './index.style';

interface AccordionHeaderProps {
  isOpen: boolean;
  isCurrent?: boolean;
  text?: string;
  subText?: string;
  defaultText: string;
  startDate?: string;
  endDate?: string;
}

function AccordionHeader(props: AccordionHeaderProps) {
  const { isOpen, isCurrent, text, defaultText, subText } = props;
  let { startDate, endDate } = props;

  if (!isOpen && text) {
    const dates = (() => {
      const isStartDateValid = validateDate(startDate);
      startDate = isStartDateValid ? moment(startDate).format('MM/YYYY') : undefined;

      if (isCurrent && startDate) {
        return `${startDate} - current`;
      } else if (startDate) {
        const isEndDateValid = validateDate(endDate);

        endDate = isEndDateValid ? moment(endDate).format('MM/YYYY') : undefined;

        if (endDate) {
          return `${startDate} - ${endDate}`;
        }
      }

      return;
    })();

    return (
      <AccordionHeaderContainer>
        <AccordionHeaderText>{text}</AccordionHeaderText>
        {dates && (
          <Body size="xs" color={getColour('text', 'subtle')}>
            {!!subText && `${subText} • `}
            {dates}
          </Body>
        )}
      </AccordionHeaderContainer>
    );
  }

  return <AccordionHeaderText>{defaultText}</AccordionHeaderText>;
}

export default AccordionHeader;
